import axios from 'axios';

import { API_ROUTE } from '@/constants/apiRoutes';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL_SOUSCRIRE_EN_LIGNE;
const faireVersementSuccesEndpoint = API_ROUTE.FAIRE_VERSEMENT_SUCCES;

export const getFaireVersementSucces = async (tokenURL: string) => {
  const versementData = JSON.parse(sessionStorage.parcoursVersementData);
  const response = await axios.post(
    `${apiBaseUrl}${faireVersementSuccesEndpoint}/${tokenURL}`,
    {},
    {
      headers: {
        token: `${versementData.token}`,
      },
    }
  );

  if (!response) {
    throw new Error('Erreur lors de la vérifiaction post universign');
  }
  const data = await response.data;
  return data;
};
